import spinners from "@components/loader/spinners"
import ListItem from "./_list_item"

export default function List(opts){
    BaseConstructor.call(this)
    let container = opts.container
    let elements = {}
    let loading = opts.loading || false
    let context = this
    let stations_list = []
    let chart_name = opts.chart_name
    
    this.generate = () =>{
        setStage()
        this.update(loading)
    }

    this.update = is_loading =>{
        loading = is_loading
        if(loading){
            loadingState()
        } else {
            this.show(true)
            buildList()
            // $(container).html('TOma  alista')
        }   
    }

    this.show = show =>{
        $(elements.container).toggle(show)
    }

    this.setList = new_list => {
        stations_list = new_list
        this.update(false)
    }

    const setStage = _ =>{
        elements.container = context.createElement('div')
        $(elements.container).addClass('pretty-scrollbar')
        $(elements.container).css({
            'display': 'flex',
            'flex-direction': 'column',
            'gap': '5px',
            'max-height': '150px',
            'overflow': 'auto',
            'box-shadow': 'rgba(0, 0, 0, 0.45) 0px 25px 20px -20px'
        })
    }

    const buildList = _ =>{
        $(elements.container).html("")
        
        stations_list.forEach(station=>{
            let listItem = new ListItem({station:station, container:elements.container, chart_name:chart_name})
            listItem.generate()
        })

        $(container).html(elements.container)
    }

    const loadingState = _ =>{
        let el = context.createElement('div', 'p-2 w-100 flex flex-h-center flex-v-center flex-v')
        let text = context.createElement('div', 'm-2', 'Carregando lista de postos próximos, aguarde...')
        $(el).append(text,spinners.defaultSpinner(1, 'red', 'sm'))
        $(elements.container).html(el)
    }
}

List.prototype = Object.create(BaseConstructor.prototype)